import colors from "../assets/style/colors";

const tinycolor = require("tinycolor2");

// Get the right text color for a given background
// Background color must be in HTML format: #4a2c34
export const getTextColor = (backgroundColor) => {
  let red = parseInt(backgroundColor.substring(1, 3), 16);
  let green = parseInt(backgroundColor.substring(3, 5), 16);
  let blue = parseInt(backgroundColor.substring(5, 7), 16);

  if (red * 0.299 + green * 0.587 + blue * 0.114 > 186) {
    return colors.black87;
  }

  return colors.white;
};

export const hexColorToDecimal = (hexColor) => {
  if (hexColor) {
    let red = hexColor.substring(0, 2);
    let green = hexColor.substring(2, 4);
    let blue = hexColor.substring(4, 6);
    red = parseInt(red, 16);
    green = parseInt(green, 16);
    blue = parseInt(blue, 16);
    return [red, green, blue];
  }
  return [0, 0, 0];
};

// color: EF12A2
export const darkenColor = (color, factor = 25) => {
  if (!color) return "";

  const tinyColor = tinycolor(`#${color}`);
  return tinyColor.darken(factor);
};
